import React, { createContext, useState, useContext, useCallback } from "react";

// Check if user is authenticated
const isAuthenticated = () => {
  const token = localStorage.getItem("token");
  const logged = localStorage.getItem("logged");
  return token && logged === "true";
};

// Create the context
const GameLaunchContext = createContext({
  gameUrl: null,
  setGameUrl: () => {},
  isGameOpen: false,
  setIsGameOpen: () => {},
  isLuckySportGame: false,
  setIsLuckySportGame: () => {},
  isAuthenticated: false,
  requireAuth: () => {},
});

// Provider component
export const GameLaunchProvider = ({ children }) => {
  const [gameUrl, setGameUrl] = useState(null);
  const [isGameOpen, setIsGameOpen] = useState(false);
  // true only when the Sports (LuckySport) tab launches a game
  const [isLuckySportGame, setIsLuckySportGame] = useState(false);

  const requireAuth = useCallback(() => {
    if (!isAuthenticated()) {
      if (window.Event) {
        window.Event.emit("show_login_modal", {
          message: "Please login to access this feature",
        });
      }
      return false;
    }
    return true;
  }, []);

  return (
    <GameLaunchContext.Provider
      value={{
        gameUrl,
        setGameUrl,
        isGameOpen,
        setIsGameOpen,
        isLuckySportGame,
        setIsLuckySportGame,
        isAuthenticated: isAuthenticated(),
        requireAuth,
      }}
    >
      {children}
    </GameLaunchContext.Provider>
  );
};

// Custom hook for using the context
export const useGameLaunch = () => useContext(GameLaunchContext);
